const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SOURCE_KEY = "lab-source";
const VISITOR_KEY = "lab-visitor";

const FB_EVENTS = { book_tour: "Schedule", enrollment_inquiry: "Lead", chat_lead: "Contact" };

export const track = (name, params = {}) => {
  if (typeof window.gtag === "function") window.gtag("event", name, params);
  if (typeof window.fbq === "function" && FB_EVENTS[name]) window.fbq("track", FB_EVENTS[name], params);
};

export const trackPageView = (pathname) => {
  if (typeof window.gtag === "function") {
    window.gtag("event", "page_view", { page_path: pathname, page_location: window.location.href });
  }
  if (typeof window.fbq === "function" && !trackPageView.first) window.fbq("track", "PageView");
  trackPageView.first = false;
};
trackPageView.first = true;

const classify = () => {
  const p = new URLSearchParams(window.location.search);
  const utmSource = (p.get("utm_source") || "").toLowerCase();
  const utmMedium = (p.get("utm_medium") || "").toLowerCase();
  const campaign = p.get("utm_campaign") || "";
  let host = "";
  try { host = document.referrer ? new URL(document.referrer).hostname.replace(/^www\./, "") : ""; } catch { host = ""; }
  const gclid = p.has("gclid") || p.has("gbraid") || p.has("wbraid");
  const paid = gclid || ["cpc", "ppc", "paid"].includes(utmMedium);

  if (gclid || utmSource.includes("google") || host.includes("google.")) return { source: paid ? "google_ads" : "google", source_detail: campaign || host };
  if (utmSource.includes("facebook") || utmSource === "fb" || p.has("fbclid") || host.includes("facebook.") || host === "fb.com") return { source: "facebook", source_detail: campaign || host };
  if (utmSource.includes("instagram") || utmSource === "ig" || host.includes("instagram.")) return { source: "instagram", source_detail: campaign || host };
  if (utmSource) return { source: "referral", source_detail: campaign ? `${utmSource} · ${campaign}` : utmSource };
  if (host && host !== window.location.hostname) return { source: "referral", source_detail: host };
  return { source: "direct", source_detail: "" };
};

export const getSource = () => {
  try {
    const saved = sessionStorage.getItem(SOURCE_KEY);
    if (saved) return JSON.parse(saved);
    const s = classify();
    sessionStorage.setItem(SOURCE_KEY, JSON.stringify(s));
    return s;
  } catch {
    return { source: "unknown", source_detail: "" };
  }
};

const visitorId = () => {
  let id = localStorage.getItem(VISITOR_KEY);
  if (!id) {
    id = `v-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
    localStorage.setItem(VISITOR_KEY, id);
  }
  return id;
};

export const trackVisit = (path) => {
  if (path.startsWith("/admin")) return;
  getSource();
  fetch(`${API}/track`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ visitor_id: visitorId(), path }),
    keepalive: true,
  }).catch(() => {});
};
